import { Link } from 'react-router-dom'
import Button from '@ui/Button'
import MetaInfo from '@common/MetaInfo'
import { SITE } from '@/constants'

export default function NotFoundPage() {
  return (
    <>
  <MetaInfo
    title={`Page Not Found | ${SITE.fullName}`}
    description="The page you are looking for does not exist or has been moved."
    noIndex
  />
       <section id="contact-cta" className="section-py contact-section not-found-page" aria-labelledby="contact-heading">
    
      <div className="bg-grid bg-grid--fill" aria-hidden="true" />
      <div className="container text-center">
        <div className="not-found-code">404</div>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-desc">The page you are looking for does not exist or has been moved.</p>
        <Button href="/" variant="primary" icon="fa-arrow-left" iconPos="left">
              Go To Home Page
            </Button>
      </div>
      </section>
    </>
  )
}